const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (event, meta = {}) => {
  try {
    fetch(`${API}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, page: window.location.pathname, meta }),
      keepalive: true,
    });
  } catch (e) { /* analytics should never break UX */ }
};

export const submitLead = async (payload) => {
  const res = await fetch(`${API}/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...payload, page: window.location.pathname }),
  });
  if (!res.ok) throw new Error("Lead submission failed");
  return res.json();
};
